<template>
  <div class="alignment">
    <template>
      <v-layout row wrap>
        <v-flex xs6 class="text-xs-left"
          ><h3 class="styleHeader">
            {{ $t("pages.Stock.Index.Sito") }}
          </h3></v-flex
        >
        <v-flex>
          <v-btn
            class="right white--text styleHeader styleAlignamentAddButton"
            :to="$i18nRoute({ name: 'StocksCreate' })"
            color="#279947"
          >
            <v-icon left>add</v-icon>
            {{ $t("pages.Stock.Index.Aggiungi") }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="[
          {
            text: this.currentLanguage.t('pages.Stock.Index.Nome'),
            value: 'name'
          },
          {
            text: this.currentLanguage.t('pages.Stock.Index.NomeServer'),
            value: 'serverName'
          },
          {
            text: this.currentLanguage.t('pages.Stock.Index.NomeDatabase'),
            value: 'dbName'
          },
          { text: '' }
        ]"
        :items="stocks"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.serverName }}</td>
          <td>{{ props.item.dbName }}</td>
          <td>
            <v-btn flat icon class="right" @click="editItem(props.item)"
              ><v-icon>edit</v-icon></v-btn
            >
          </td>
        </template>
      </v-data-table>
      <!-- <Grid
        controller="Stocks/"
        readAll="GetStocksInternalPost"
        :customFilters="customFilters"
        :title="controller"
        :CanCreate="false"
        :disableEdit="false"
        :disableDelete="false"
        :hideColumns="['RowNum']"
        :refresh="reloadGridData"
        edit="Create"
      /> -->
    </template>
  </div>
</template>

<script>
import stocksApi from "../../apiSmartLogistics/stocksApi.js";
import router from "@/router/index.js";

import { Trans } from "@/plugins/Translation";
export default {
  //components: { Grid },
  data() {
    return {
      stocks: [],
      customFilters: [
        {
          text: "Larghezza",
          value: "Width",
          type: Number
        },
        {
          text: "Altezza",
          value: "Height",
          type: Number
        },
        {
          text: "CancLogica",
          value: "LogicDelete",
          type: Boolean
        }
      ],
      reloadGridData: false,
      controller: "Stocks",
      readMethod: "GetStocksInternalPost"
    };
  },
  computed: {
    currentLanguage() {
      return Trans.i18n;
    }
  },
  methods: {
    editItem(item) {
      router.push({ name: "StocksCreate", params: { id: item.id } });
    }
  },
  created() {
    stocksApi.GetStocksInternal().then(response => {
      this.stocks = response.data;
    });
  }
};
</script>
